module.exports = __webpack_public_path__ + "static/media/lobby.b964a193.jpeg";